import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeCitizensAttendancesIndicatorM2Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class ResumeCitizenAttendancesIndicatorM2Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	totalAttendances: number = 0;
	totalSharedAttendances: number = 0;
	totalNonSharedAttendances: number = 0;
}

export async function getResumeCitizensAttendancesIndicatorM2({
	uf,
	ibgeCode,
	...params
}: ResumeCitizensAttendancesIndicatorM2Params) {
	const response = await esusApi.get<Paginated<ResumeCitizenAttendancesIndicatorM2Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/emulti/m2/resume-citizens-attendances`,
		params
	);
	return response.data ?? new Paginated<ResumeCitizenAttendancesIndicatorM2Data>();
}
